import { replaceIndex } from 'core/util/arrays';

export const toBool = (str?: string): boolean | undefined => {
    if (str === 'true') {
        return true;
    }
    if (str === 'false') {
        return false;
    }
};

export const pluralize = (noun: string, count: number, plural = `${noun}s`): string => {
    return count === 1 ? noun : plural;
};

export const monetize = (amount: number, options?: Intl.NumberFormatOptions): string => {
    const numberFormatOptions: Intl.NumberFormatOptions = {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'symbol',
        ...options,
    };
    return amount.toLocaleString('en-us', numberFormatOptions);
};

export const ordinalSuffixFor = (n: number): string => {
    const j = n % 10;
    const k = n % 100;
    if (j === 1 && k !== 11) {
        return `${n}st`;
    }
    if (j === 2 && k !== 12) {
        return `${n}nd`;
    }
    if (j === 3 && k !== 13) {
        return `${n}rd`;
    }
    return `${n}th`;
};

export const markRequired = (label: string, required?: boolean): string => {
    const prefix = required ? '*' : '';
    return prefix + label;
};

export const conjunctify = (strings: string[], conjunction = 'and'): string => {
    if (strings.length < 3) {
        return strings.join(` ${conjunction} `);
    }
    return replaceIndex(strings, strings.length - 1, (str) => `${conjunction} ${str}`).join(', ');
};

export const toPositiveWholeNumber = (value: string) => {
    return Number(value.replace(/\D/g, ''));
};

export const numberToLocaleString = (n: number) => Number(n).toLocaleString();

export const addressAllowedCharacters = (): number[] => {
    // Creates an array of numbers 32 to 126, inclusive, then removes 63 and 60
    const acceptedCharacters = Array.from({ length: 126 - 32 + 1 }, (_, i) => i + 32);
    // 63: ?, 60: <
    acceptedCharacters.splice(63 - 32, 1);
    acceptedCharacters.splice(60 - 32, 1);
    return acceptedCharacters;
};

export const doesStringContainSpecialCharacters = (value: string | null): boolean => {
    if (!value) {
        return false;
    }
    let contains = false;
    const allowedCharacters = addressAllowedCharacters();
    for (let i = 0; i < value.length; i++) {
        const char = value[i];
        if (!allowedCharacters.includes(char.charCodeAt(0))) {
            contains = true;
        }
    }

    return contains;
};
